export const setData = (state, data) => {
  state.data = data
  state.dataVersion += 1
}

export const setLoading = (state, value) => {
  state.loading = value
}
